import { render, staticRenderFns } from "./PublicCalculator.vue?vue&type=template&id=37134bc3&scoped=true&"
import script from "./PublicCalculator.vue?vue&type=script&lang=js&"
export * from "./PublicCalculator.vue?vue&type=script&lang=js&"
import style0 from "./PublicCalculator.vue?vue&type=style&index=0&id=37134bc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37134bc3",
  null
  
)

export default component.exports